(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-quantity-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('.cart-page__stepper-input');

    stepper.querySelectorAll('.cart-page__stepper-btn').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = parseInt(button.dataset.step, 10);
        var min = parseInt(input.min, 10) || 0;
        var next = (parseInt(input.value, 10) || 0) + step;

        input.value = Math.max(min, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-drawer-open]').forEach(function (opener) {
      opener.addEventListener('click', function () {
        var drawer = document.getElementById(opener.getAttribute('aria-controls'));
        if (drawer && typeof drawer.showModal === 'function') {
          drawer.showModal();
          opener.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
      drawer.addEventListener('close', function () {
        var opener = document.querySelector('[aria-controls="' + drawer.id + '"]');
        if (opener) {
          opener.setAttribute('aria-expanded', 'false');
        }
      });

      drawer.addEventListener('click', function (event) {
        if (event.target === drawer) {
          drawer.close();
        }
      });

      drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          drawer.close();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.product-offer');
    if (!root) {
      return;
    }

    // Gallery: same thumbnail <-> scroll-track pattern as the product page,
    // duplicated here (rather than shared) because the product page must
    // stay untouched and this section renders a different product.
    var track = root.querySelector('[data-showcase-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-showcase-slide]')) : [];
    var thumbs = root.querySelectorAll('[data-showcase-thumb]');
    var activeIndex = 0;

    function updateThumbs() {
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === activeIndex);
      });
    }

    if (track && slides.length > 1) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                activeIndex = slides.indexOf(entry.target);
                updateThumbs();
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      updateThumbs();

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var target = slides[parseInt(thumb.dataset.index, 10)];
          if (target) {
            track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          }
        });
      });
    }

    var form = root.querySelector('.product-offer__form');
    var ctaButton = root.querySelector('.product-offer__cta');
    if (form && ctaButton) {
      form.addEventListener('submit', function () {
        ctaButton.disabled = true;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var root = document;

    function collapseAccordionPanel(toggle, panel) {
      toggle.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-expanded');
      panel.addEventListener('transitionend', function onCollapseEnd(event) {
        if (event.target !== panel) {
          return;
        }
        panel.hidden = true;
        panel.removeEventListener('transitionend', onCollapseEnd);
      });
    }

    function expandAccordionPanel(toggle, panel) {
      panel.hidden = false;
      void panel.offsetHeight;
      panel.classList.add('is-expanded');
      toggle.setAttribute('aria-expanded', 'true');
    }

    var accordion = root.querySelector('[data-product-accordion]');
    if (accordion) {
      var accordionToggles = Array.prototype.slice.call(accordion.querySelectorAll('[data-accordion-toggle]'));

      accordionToggles.forEach(function (toggle) {
        var panel = root.getElementById(toggle.getAttribute('aria-controls'));
        if (!panel) {
          return;
        }

        toggle.addEventListener('click', function () {
          var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

          accordionToggles.forEach(function (otherToggle) {
            if (otherToggle === toggle || otherToggle.getAttribute('aria-expanded') !== 'true') {
              return;
            }
            var otherPanel = root.getElementById(otherToggle.getAttribute('aria-controls'));
            if (otherPanel) {
              collapseAccordionPanel(otherToggle, otherPanel);
            }
          });

          if (isExpanded) {
            collapseAccordionPanel(toggle, panel);
          } else {
            expandAccordionPanel(toggle, panel);
          }
        });
      });
    }

    var gallery = root.querySelector('[data-product-gallery]');
    var galleryTrack = gallery ? gallery.querySelector('[data-gallery-track]') : null;
    var gallerySlides = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]')) : [];
    var galleryThumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]')) : [];
    var galleryActiveIndex = 0;

    function updateGalleryControls() {
      galleryThumbs.forEach(function (thumb, i) {
        var isActive = i === galleryActiveIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function scrollGalleryToIndex(index) {
      var target = gallerySlides[index];
      if (target && galleryTrack) {
        galleryTrack.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    }

    function goToGalleryMediaId(mediaId) {
      if (!mediaId || !gallerySlides.length) {
        return;
      }
      var index = gallerySlides.findIndex(function (slide) {
        return slide.dataset.mediaId === String(mediaId);
      });
      if (index > -1) {
        galleryActiveIndex = index;
        updateGalleryControls();
        scrollGalleryToIndex(index);
      }
    }

    if (galleryTrack && gallerySlides.length > 1) {
      if ('IntersectionObserver' in window) {
        var slideObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                galleryActiveIndex = gallerySlides.indexOf(entry.target);
                updateGalleryControls();
              }
            });
          },
          { root: galleryTrack, threshold: 0.6 }
        );

        gallerySlides.forEach(function (slide) {
          slideObserver.observe(slide);
        });
      }

      updateGalleryControls();

      galleryThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          scrollGalleryToIndex(parseInt(thumb.dataset.index, 10));
        });
      });
    }

    var form = root.querySelector('.product-main__form');
    var variantInput = form ? form.querySelector('[data-product-variant-id]') : null;
    var ctaButton = root.querySelector('[data-product-cta]');
    var ctaLabel = ctaButton ? ctaButton.querySelector('[data-product-cta-label]') : null;
    var priceEl = root.querySelector('[data-product-price]');
    var comparePriceEl = root.querySelector('[data-product-price-compare]');
    var optionSelects = Array.prototype.slice.call(root.querySelectorAll('[data-option-select]'));

    var stickyBar = document.querySelector('[data-product-sticky]');
    var stickyPriceEl = stickyBar ? stickyBar.querySelector('[data-product-sticky-price]') : null;
    var stickyButton = stickyBar ? stickyBar.querySelector('[data-product-sticky-button]') : null;

    var finalPriceEl = document.querySelector('[data-product-final-price]');
    var finalButton = document.querySelector('[data-product-final-button]');
    var finalVariantInput = document.querySelector('[data-product-final-variant-id]');
    var finalQuantityInput = document.querySelector('[data-product-final-quantity]');
    var mainQuantityInput = form ? form.querySelector('input[name="quantity"]') : null;

    var addLabel = ctaLabel ? ctaLabel.textContent.trim() : '';
    var soldOutLabel = stickyButton ? stickyButton.dataset.labelSoldOut : '';
    var addedLabel = stickyButton ? stickyButton.dataset.labelAdded : '';
    if (stickyButton && stickyButton.dataset.labelAdd) {
      addLabel = stickyButton.dataset.labelAdd;
    }

    var variantsData = null;
    var variantsScript = form ? form.querySelector('[data-product-variants]') : null;
    if (variantsScript) {
      try {
        variantsData = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variantsData = null;
      }
    }

    function setUnavailableState() {
      if (ctaButton) {
        ctaButton.disabled = true;
      }
      if (ctaLabel) {
        ctaLabel.textContent = soldOutLabel || addLabel;
      }
      if (stickyButton) {
        stickyButton.disabled = true;
        stickyButton.textContent = soldOutLabel;
      }
      if (finalButton) {
        finalButton.disabled = true;
        finalButton.textContent = soldOutLabel;
      }
    }

    function applyVariant(variant) {
      if (!variant) {
        setUnavailableState();
        return;
      }

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (finalVariantInput) {
        finalVariantInput.value = variant.id;
        finalVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (variant.featured_media_id) {
        goToGalleryMediaId(variant.featured_media_id);
      }

      if (priceEl) {
        priceEl.textContent = variant.price;
      }
      if (stickyPriceEl) {
        stickyPriceEl.textContent = variant.price;
      }
      if (finalPriceEl) {
        finalPriceEl.textContent = variant.price;
      }

      if (comparePriceEl) {
        if (variant.compare_at_price) {
          comparePriceEl.textContent = variant.compare_at_price;
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.hidden = true;
        }
      }

      updateBundleOptionPrices(variant.id);

      var available = !!variant.available;
      if (ctaButton) {
        ctaButton.disabled = !available;
      }
      if (ctaLabel) {
        ctaLabel.textContent = available ? addLabel : soldOutLabel;
      }
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = available ? addLabel : soldOutLabel;
      }
      if (finalButton) {
        finalButton.disabled = !available;
        finalButton.textContent = available ? addLabel : soldOutLabel;
      }
    }

    if (variantsData && optionSelects.length) {
      optionSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          var selected = optionSelects.map(function (s) {
            return s.value;
          });
          var match = variantsData.find(function (variant) {
            return variant.options.every(function (value, index) {
              return value === selected[index];
            });
          });
          applyVariant(match);
        });
      });
    }

    var bundleSelector = root.querySelector('[data-bundle-selector]');
    var bundleOptionEls = bundleSelector
      ? Array.prototype.slice.call(bundleSelector.querySelectorAll('[data-bundle-option]'))
      : [];

    // Each bundle option embeds its own pre-formatted price/compare/savings
    // text for every variant (rendered server-side by Liquid, using the
    // shop's real money format) — this just swaps which precomputed string
    // is shown. No price math or formatting happens in JavaScript.
    function updateBundleOptionPrices(variantId) {
      bundleOptionEls.forEach(function (optionEl) {
        var pricesScript = optionEl.querySelector('[data-bundle-prices]');
        if (!pricesScript) {
          return;
        }

        var pricesData;
        try {
          pricesData = JSON.parse(pricesScript.textContent);
        } catch (e) {
          return;
        }

        var entry = pricesData[String(variantId)];
        if (!entry) {
          return;
        }

        var priceEl = optionEl.querySelector('[data-bundle-price]');
        if (priceEl) {
          priceEl.textContent = entry.price;
        }

        var compareEl = optionEl.querySelector('[data-bundle-compare]');
        if (compareEl) {
          if (entry.compare) {
            compareEl.textContent = entry.compare;
            compareEl.hidden = false;
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
          }
        }

        var savingsEl = optionEl.querySelector('[data-bundle-savings]');
        if (savingsEl) {
          if (entry.savings) {
            savingsEl.textContent = entry.savings;
            savingsEl.hidden = false;
          } else {
            savingsEl.textContent = '';
            savingsEl.hidden = true;
          }
        }
      });
    }

    if (bundleSelector && mainQuantityInput) {
      var bundleRadios = Array.prototype.slice.call(bundleSelector.querySelectorAll('[data-bundle-radio]'));

      var applyBundleQuantity = function (radio) {
        var quantity = parseInt(radio.value, 10) || 1;
        mainQuantityInput.value = quantity;
        mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      var checkedRadio = bundleRadios.filter(function (radio) {
        return radio.checked;
      })[0];
      if (checkedRadio) {
        applyBundleQuantity(checkedRadio);
      }

      bundleRadios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) {
            applyBundleQuantity(radio);
          }
        });
      });
    }

    if (mainQuantityInput && finalQuantityInput) {
      var syncFinalQuantity = function () {
        finalQuantityInput.value = mainQuantityInput.value;
        finalQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      };
      syncFinalQuantity();
      mainQuantityInput.addEventListener('input', syncFinalQuantity);
      mainQuantityInput.addEventListener('change', syncFinalQuantity);
    }

    var addUrl = stickyButton ? stickyButton.dataset.addUrl : null;
    var cartUrl = stickyBar ? stickyBar.dataset.cartUrl : null;
    var headerCartLink = cartUrl ? document.querySelector('header a[href="' + cartUrl + '"]') : null;

    function updateHeaderCartCount(count) {
      if (!headerCartLink) {
        return;
      }
      var badge = headerCartLink.querySelector('sup');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('sup');
          headerCartLink.prepend(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    }

    var isSubmitting = false;

    function getQuantity() {
      var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }

    // The sticky bar is the only Add to Cart control that stays on the page:
    // it adds via Ajax, flashes "Added", updates the header cart count, and
    // never navigates. The main purchase button and the final CTA button are
    // real form submits (see the `return_to` hidden input in their markup)
    // so a successful add takes the customer straight to the cart page.
    function restoreStickyButton() {
      if (stickyButton) {
        stickyButton.textContent = stickyButton.disabled ? soldOutLabel : addLabel;
      }
    }

    function addToCart() {
      if (!addUrl || !variantInput || isSubmitting || (stickyButton && stickyButton.disabled)) {
        return;
      }

      isSubmitting = true;
      var quantity = getQuantity();

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: variantInput.value, quantity: quantity }),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }
          return response.json();
        })
        .then(function () {
          if (stickyButton) {
            stickyButton.textContent = addedLabel;
          }

          if (!cartUrl) {
            return null;
          }
          return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (response) {
            return response.ok ? response.json() : null;
          });
        })
        .then(function (cartState) {
          if (cartState) {
            updateHeaderCartCount(cartState.item_count);
          }
          setTimeout(function () {
            isSubmitting = false;
            restoreStickyButton();
          }, 1600);
        })
        .catch(function () {
          isSubmitting = false;
          restoreStickyButton();
        });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', addToCart);
    }

    if (form && ctaButton) {
      form.addEventListener('submit', function () {
        ctaButton.disabled = true;
      });
    }

    var finalForm = finalButton ? finalButton.closest('form') : null;
    if (finalForm && finalButton) {
      finalForm.addEventListener('submit', function () {
        finalButton.disabled = true;
      });
    }

    if (stickyBar && ctaButton && 'IntersectionObserver' in window) {
      // Whether the main "Add to Cart" button has actually scrolled past
      // (above) the viewport — not merely "isn't currently visible", which
      // is also true before the customer has scrolled down to it yet.
      var mainCtaPassed = false;
      // Hide the sticky bar again once the final CTA further down the page
      // is on screen, so the two never show at the same time.
      var finalCtaVisible = false;
      var finalCtaSection = document.querySelector('.product-cta');

      var updateStickyVisibility = function () {
        stickyBar.classList.toggle('is-visible', mainCtaPassed && !finalCtaVisible);
      };

      var mainCtaObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // Fully scrolled above the viewport (bottom edge above the top)
            // means the customer scrolled past it. Below the viewport —
            // not yet reached — also reports isIntersecting: false, but its
            // boundingClientRect.bottom stays positive, so it's excluded.
            mainCtaPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          });
          updateStickyVisibility();
        },
        { threshold: 0 }
      );
      mainCtaObserver.observe(ctaButton);

      if (finalCtaSection) {
        var finalCtaObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              finalCtaVisible = entry.isIntersecting;
            });
            updateStickyVisibility();
          },
          { threshold: 0 }
        );
        finalCtaObserver.observe(finalCtaSection);
      }
    }

    var compactReviewCarousel = root.querySelector('[data-compact-review-carousel]');
    if (compactReviewCarousel) {
      var compactReviewTrack = compactReviewCarousel.querySelector('[data-compact-review-track]');
      var compactReviewSlides = compactReviewTrack ? Array.prototype.slice.call(compactReviewTrack.children) : [];
      var compactReviewDots = Array.prototype.slice.call(
        compactReviewCarousel.querySelectorAll('[data-compact-review-dot]')
      );
      var compactReviewPrevButton = compactReviewCarousel.querySelector('[data-compact-review-prev]');
      var compactReviewNextButton = compactReviewCarousel.querySelector('[data-compact-review-next]');

      if (compactReviewTrack && compactReviewSlides.length > 1) {
        var compactReviewActiveIndex = 0;

        var updateCompactReviewControls = function () {
          compactReviewDots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === compactReviewActiveIndex);
          });
          if (compactReviewPrevButton) {
            compactReviewPrevButton.disabled = compactReviewActiveIndex === 0;
          }
          if (compactReviewNextButton) {
            compactReviewNextButton.disabled = compactReviewActiveIndex === compactReviewSlides.length - 1;
          }
        };

        if ('IntersectionObserver' in window) {
          var compactReviewObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  compactReviewActiveIndex = compactReviewSlides.indexOf(entry.target);
                  updateCompactReviewControls();
                }
              });
            },
            { root: compactReviewTrack, threshold: 0.6 }
          );

          compactReviewSlides.forEach(function (slide) {
            compactReviewObserver.observe(slide);
          });
        }

        updateCompactReviewControls();

        compactReviewDots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var index = parseInt(dot.dataset.index, 10);
            var target = compactReviewSlides[index];
            if (target) {
              compactReviewTrack.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
            }
          });
        });

        var scrollCompactReviewBySlide = function (direction) {
          var step = compactReviewSlides[0].getBoundingClientRect().width;
          compactReviewTrack.scrollBy({ left: direction * step, behavior: 'smooth' });
        };

        if (compactReviewPrevButton) {
          compactReviewPrevButton.addEventListener('click', function () {
            scrollCompactReviewBySlide(-1);
          });
        }
        if (compactReviewNextButton) {
          compactReviewNextButton.addEventListener('click', function () {
            scrollCompactReviewBySlide(1);
          });
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document;

    var carousel = root.querySelector('[data-testimonial-carousel]');
    if (!carousel) {
      return;
    }

    var track = carousel.querySelector('[data-testimonial-track]');
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-testimonial-dot]'));
    var prevButton = carousel.querySelector('[data-testimonial-prev]');
    var nextButton = carousel.querySelector('[data-testimonial-next]');

    if (!track || cards.length < 2) {
      return;
    }

    var activeIndex = 0;

    function updateControls() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
      });
      if (prevButton) {
        prevButton.disabled = activeIndex === 0;
      }
      if (nextButton) {
        nextButton.disabled = activeIndex === cards.length - 1;
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              activeIndex = cards.indexOf(entry.target);
              updateControls();
            }
          });
        },
        { root: track, threshold: 0.6 }
      );

      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    updateControls();

    function updateOverflow() {
      carousel.classList.toggle('is-scrollable', track.scrollWidth > track.clientWidth + 1);
    }

    updateOverflow();

    var resizeTimeout;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(updateOverflow, 150);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.index, 10);
        var target = cards[index];
        if (target) {
          track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      });
    });

    function scrollByCard(direction) {
      var firstCard = cards[0];
      var step = firstCard.getBoundingClientRect().width;
      var trackStyle = window.getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
      track.scrollBy({ left: direction * (step + gap), behavior: 'smooth' });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        scrollByCard(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollByCard(1);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar || !('IntersectionObserver' in window)) {
      return;
    }

    var nameEl = bar.querySelector('[data-sticky-atc-name]');
    var priceEl = bar.querySelector('[data-sticky-atc-price]');
    var button = bar.querySelector('[data-sticky-atc-button]');

    var sourceForm = document.querySelector('.product-offer__form');
    var variantInput = sourceForm ? sourceForm.querySelector('input[name="id"]') : null;
    var sourceName = document.querySelector('.product-offer .visually-hidden');
    var sourcePrice = document.querySelector('.product-offer__price');
    var sourceCta = document.querySelector('.product-offer__cta');

    if (!variantInput || !sourceName || !sourcePrice || !button || !nameEl) {
      return;
    }

    var addLabel = button.dataset.labelAdd;
    var soldOutLabel = button.dataset.labelSoldOut;
    var addedLabel = button.dataset.labelAdded;
    var addUrl = button.dataset.addUrl;
    var cartUrl = bar.dataset.cartUrl;
    var headerCartLink = cartUrl ? document.querySelector('header a[href="' + cartUrl + '"]') : null;

    function isUnavailable() {
      return !!(sourceCta && sourceCta.disabled);
    }

    function syncProductState() {
      nameEl.textContent = sourceName.textContent.trim();

      var productUrl = sourceName.getAttribute('href');
      if (productUrl) {
        nameEl.setAttribute('href', productUrl);
      }

      priceEl.textContent = sourcePrice.textContent.trim();
      button.disabled = isUnavailable();
      button.textContent = button.disabled ? soldOutLabel : addLabel;
    }

    function updateHeaderCartCount(count) {
      if (!headerCartLink) {
        return;
      }

      var badge = headerCartLink.querySelector('sup');

      if (count > 0) {
        if (!badge) {
          badge = document.createElement('sup');
          headerCartLink.prepend(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    }

    syncProductState();

    var atTop = true;
    var ctaVisible = false;

    function updateVisibility() {
      bar.classList.toggle('is-visible', !atTop && !ctaVisible);
    }

    var topSentinel = document.createElement('div');
    topSentinel.setAttribute('aria-hidden', 'true');
    topSentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
    document.body.prepend(topSentinel);

    var topObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        atTop = entry.isIntersecting;
      });
      updateVisibility();
    });
    topObserver.observe(topSentinel);

    var ctaSelectors = ['.video-hero__button', '.product-offer__cta', '.final-cta__button'];
    var ctaVisibility = new Map();

    ctaSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        ctaVisibility.set(el, false);
      });
    });

    if (ctaVisibility.size) {
      var ctaObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            ctaVisibility.set(entry.target, entry.isIntersecting);
          });
          ctaVisible = Array.from(ctaVisibility.values()).some(Boolean);
          updateVisibility();
        },
        { threshold: 0 }
      );

      ctaVisibility.forEach(function (visible, el) {
        ctaObserver.observe(el);
      });
    }

    var isSubmitting = false;

    button.addEventListener('click', function () {
      if (button.disabled || isSubmitting || !addUrl) {
        return;
      }

      isSubmitting = true;
      button.disabled = true;

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: variantInput.value, quantity: 1 }),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }
          return response.json();
        })
        .then(function () {
          button.textContent = addedLabel;
          document.dispatchEvent(new CustomEvent('cart:updated'));

          if (!cartUrl) {
            return null;
          }

          return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (response) {
            return response.ok ? response.json() : null;
          });
        })
        .then(function (cartState) {
          if (cartState) {
            updateHeaderCartCount(cartState.item_count);
          }

          setTimeout(function () {
            isSubmitting = false;
            syncProductState();
          }, 1600);
        })
        .catch(function () {
          isSubmitting = false;
          syncProductState();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carousel = document.querySelector('.testimonials [data-testimonial-carousel]');
    if (!carousel) {
      return;
    }

    var track = carousel.querySelector('[data-testimonial-track]');
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-testimonial-dot]'));
    var prevButton = carousel.querySelector('[data-testimonial-prev]');
    var nextButton = carousel.querySelector('[data-testimonial-next]');

    if (!track || cards.length < 2) {
      return;
    }

    var activeIndex = 0;

    function updateControls() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
      });
      if (prevButton) {
        prevButton.disabled = activeIndex === 0;
      }
      if (nextButton) {
        nextButton.disabled = activeIndex === cards.length - 1;
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              activeIndex = cards.indexOf(entry.target);
              updateControls();
            }
          });
        },
        { root: track, threshold: 0.6 }
      );

      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    updateControls();

    function updateOverflow() {
      carousel.classList.toggle('is-scrollable', track.scrollWidth > track.clientWidth + 1);
    }

    updateOverflow();

    var resizeTimeout;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(updateOverflow, 150);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.index, 10);
        var target = cards[index];
        if (target) {
          track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      });
    });

    function scrollByCard(direction) {
      var firstCard = cards[0];
      var step = firstCard.getBoundingClientRect().width;
      var trackStyle = window.getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
      track.scrollBy({ left: direction * (step + gap), behavior: 'smooth' });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        scrollByCard(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollByCard(1);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var videos = document.querySelectorAll('.video-showcase__asset');
    if (!videos.length || !window.matchMedia) {
      return;
    }

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    videos.forEach(function (asset) {
      if (asset.tagName === 'VIDEO') {
        asset.pause();
        asset.removeAttribute('autoplay');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
